import type { KpiComputedPayload } from '../servicebus/kpi';
import { KPI_GRANULARITY, KPI_KEYS } from '../kpi/kpi.interface';
import { ObjectFactory } from './object.factory';

export class KpiComputedPayloadFactory extends ObjectFactory<KpiComputedPayload> {
  protected getDefaults(): KpiComputedPayload {
    return {
      from: { day: 1, month: 9, year: 2026 },
      granularity: KPI_GRANULARITY.MONTH,
      key: KPI_KEYS.ORDER_KPIS,
      kpiId: 'aabbccddeeff001122334455',
      metrics: { anomaly: 0, completed: 3, failed: 0, inprogress: 1, total: 5, unassigned: 1 },
      to: { day: 30, month: 9, year: 2026 },
    };
  }
}

// Pre-instantiated for convenience
export const kpiComputedPayloadFactory = new KpiComputedPayloadFactory();
